import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Anchor, Map, FileCheck } from 'lucide-react';
export function HeroSection() {
  return <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-152">
      {/* Parallax Background */}
      <div className="absolute inset-0 z-0 parallax" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/erqEotuB1nebB1RPsmLmqP/187.jpg')"
    }} data-id="element-153">
        <div className="absolute inset-0 bg-black/60 mix-blend-multiply" data-id="element-154" />
        <div className="absolute inset-0 bg-navy/30" data-id="element-155" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-20" data-id="element-156">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-157">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-heading font-bold text-white mb-6 uppercase tracking-tight leading-tight drop-shadow-lg" data-id="element-158">
            World-Class Marine Surveying <br className="hidden md:block" data-id="element-159" />
            <span className="text-gray-200" data-id="element-160">on the Gulf Coast</span>
          </h1>

          <p className="mt-4 max-w-3xl mx-auto text-lg sm:text-xl text-gray-200 mb-10 font-light leading-relaxed" data-id="element-161">
            NAMS-certified marine surveyors, consultants, appraisers & auditors
            — providing fast, accurate, unbiased reporting since day one.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-16" data-id="element-162">
            <a href="#contact" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-bold uppercase tracking-wider text-white bg-accent hover:bg-red-700 transition-all duration-300 shadow-lg hover:shadow-xl min-w-[200px]" data-id="element-163">
              Request a Survey
            </a>
            <a href="#services" className="inline-flex items-center justify-center px-8 py-4 border-2 border-white text-base font-bold uppercase tracking-wider text-white hover:bg-white hover:text-navy transition-all duration-300 min-w-[200px]" data-id="element-164">
              View Our Services
            </a>
          </div>
        </motion.div>

        {/* Trust Strip */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4,
        duration: 0.8
      }} className="grid grid-cols-2 md:grid-cols-4 gap-6 border-t border-white/20 pt-8 mt-8" data-id="element-165">
          <div className="flex flex-col items-center justify-center text-white/90" data-id="element-166">
            <ShieldCheck className="w-8 h-8 mb-2 text-accent" data-id="element-167" />
            <span className="text-sm font-bold uppercase tracking-wider" data-id="element-168">
              NAMS-CMS Certified
            </span>
          </div>
          <div className="flex flex-col items-center justify-center text-white/90" data-id="element-169">
            <Anchor className="w-8 h-8 mb-2 text-accent" data-id="element-170" />
            <span className="text-sm font-bold uppercase tracking-wider" data-id="element-171">
              100+ Years Experience
            </span>
          </div>
          <div className="flex flex-col items-center justify-center text-white/90" data-id="element-172">
            <Map className="w-8 h-8 mb-2 text-accent" data-id="element-173" />
            <span className="text-sm font-bold uppercase tracking-wider" data-id="element-174">
              Gulf Coast Coverage
            </span>
          </div>
          <div className="flex flex-col items-center justify-center text-white/90" data-id="element-175">
            <FileCheck className="w-8 h-8 mb-2 text-accent" data-id="element-176" />
            <span className="text-sm font-bold uppercase tracking-wider" data-id="element-177">
              Fully Insured Access
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}